import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChartStatisticsFilterForm, StatisticsFilterForm } from 'src/app/shared/interfaces';

import { WhiteLabelDashboardApi } from '../api/white-label-dashboard-api';
import {
  EnthusiastsStatisticsModel,
  WhiteLabelChartStatistics,
  WhiteLabelMapStatisticsModel,
  WhiteLabelPdfGendersStatistics,
  WhiteLabelTotalWithAverageSessions,
  WhiteLabelUsersCommentsWithRate,
} from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class WhiteLabelDashboardRepository extends Repository {
  constructor(private whiteLabelDashboardApi: WhiteLabelDashboardApi) {
    super();
  }

  getQuranEnthusiastsStatistics(): Observable<EnthusiastsStatisticsModel> {
    return this.whiteLabelDashboardApi.getQuranEnthusiastsStatistics();
  }
  getApplicationTotalSessionData(form: StatisticsFilterForm): Observable<WhiteLabelTotalWithAverageSessions> {
    return this.whiteLabelDashboardApi.getApplicationTotalSessionData(form);
  }

  getUsersCommentsAndRate(categories: string[]): Observable<WhiteLabelUsersCommentsWithRate> {
    return this.whiteLabelDashboardApi.getUsersCommentsAndRate(categories);
  }
  getChartStatistics(form: ChartStatisticsFilterForm): Observable<WhiteLabelChartStatistics[]> {
    return this.whiteLabelDashboardApi.getChartStatistics(form);
  }
  getMapStatistics(): Observable<WhiteLabelMapStatisticsModel> {
    return this.whiteLabelDashboardApi.getMapStatistics();
  }
  getPDFGendersCount(form: StatisticsFilterForm): Observable<WhiteLabelPdfGendersStatistics> {
    return this.whiteLabelDashboardApi.getPDFGendersCount(form);
  }
}
